// return ?q=xxxx
export function getQueryString<T>(obj: T): string {
  const query: string[][] = Object.keys(obj).map((k: string) => {
    return [k, obj[k as keyof T]?.toString()]
  })
  return `?${new URLSearchParams(query).toString()}`
}
